import * as React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { observer, inject } from "mobx-react";
import * as moment from 'moment';
import history from '../history';
import { Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import InfoIcon from '@material-ui/icons/Info';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';

// =====================================
// CONSTS
import { Messages } from '../../const/Messages';

// =====================================
// STORES
import { IOrdersStore } from '../../store/OrdersStore';
import { ICommonStore } from '../../store/CommonStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { Loader } from '../Layout/Loader';

@inject((allStores: any) => ({
    commonStore: allStores.store.commonStore as ICommonStore,
    ordersStore: allStores.store.ordersStore as IOrdersStore
}))

@observer
export default class AcceptedOrders extends React.Component<{ ordersStore?: IOrdersStore; commonStore?: ICommonStore; match?: any }, {}> {

    componentDidMount() {
        const customerId = this.props.match?.params?.customerId;
        this.props.ordersStore.getAcceptedOrders(customerId);
    }

    componentWillUnmount() {
        this.props.ordersStore.reset();
    }

    redirectToNewOrder = () => {
        history.push(`/neworder/${this.props.match?.params?.customerId}`);
    }

    render() {

        if (this.props.ordersStore.isLoading) {
            return <Loader />;
        }

        return (
            <div>
                <Header
                    title={`Klijent: ${this.props.ordersStore.customer.fullName}`}
                    isBackButtonVisible={true}
                    url="/customers" />

                <Fab color="primary" aria-label="add" className="add-btn" onClick={this.redirectToNewOrder}>
                    <AddIcon />
                </Fab>

                <div className="container orders-wrapper">
                    {!this.props.ordersStore.isAcceptedOrderEmpty ?
                        <div>
                            {this.props.ordersStore.acceptedOrders.map((order, i) => {
                                return <Link to={`/orderdetails/${this.props.match?.params?.customerId}/${order.id}/false`} key={i} className="order-container">
                                    <div className="flex-wrapper">
                                        <div className="image-container">
                                            <span className="material-icons" style={{ backgroundColor: this.props.commonStore.getOrderStatusColor(order.status.code) }}>
                                                {this.props.commonStore.getOrderStatusIcon(order.status.code)}
                                            </span>
                                        </div>

                                        <div className="full-width-row">
                                            <div className="order-row">ID: {order.number} {order.ERPOrderReferenceCode !== "" ? `- ${order.ERPOrderReferenceCode}` : ""}</div>
                                            <div className="order-row">Kompanija: {order.customer.name}</div>
                                            <div className="order-row">Korisnik: {order.customer.contactPersons[0].name}</div>
                                            <div className="order-row">Kreirano: {moment(order.createdAt.seconds * 1000).format("DD.MM.YYYY HH:mm")}</div>
                                            <div className="order-row">Status:
                                                <span className="text-uppercase" style={{ color: this.props.commonStore.getOrderStatusColor(order.status.code) }}>
                                                    {this.props.commonStore.getOrderStatus(order.status.code)}
                                                </span>
                                            </div>
                                        </div>

                                        <div>
                                            <span className="highlight-sign">
                                                {order.products.filter((product) => product.offeredAmount === 0).length > 0 ? <PriorityHighIcon /> : ""}
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            })}</div>
                        : <div className="no_data">{Messages.NO_ORDERS}</div>}
                </div>

                <div className="footer-icon-container">
                    <NavLink className="footer-icon col-4" to={`/orders/${this.props.match?.params?.customerId}`}>
                        <AddShoppingCartIcon />
                        <div>Aktivne</div>
                    </NavLink>
                    <NavLink className="footer-icon col-4" to={`/acceptedorders/${this.props.match?.params?.customerId}`}>
                        <ShoppingCartIcon />
                        <div>Realizovane</div>
                    </NavLink>
                    <NavLink className="footer-icon col-4" to={`/info/${this.props.match?.params?.customerId}`}>
                        <InfoIcon />
                        <div>Info</div>
                    </NavLink>
                </div>
            </div>
        );
    }
}